import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/developer/www/bazz.bet/bzfront/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/home/developer/www/bazz.bet/bzfront/src/components/layouts/page-header/index.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/developer/www/bazz.bet/bzfront/src/components/Pages/terms-and-conditions/page.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/developer/www/bazz.bet/bzfront/src/components/UI/BackButton/BackButton.tsx");
